import {
  getData,
  postData
} from './api-base.service';


export const removeDevice = (integerDeviceId) => {

  let result = getData('/StudentDevice/RemoveStudentDevice?deviceIntegerId='+ integerDeviceId);
  return result;
}


export const getAllStudentDevices = (data) => {

  let result = postData('/StudentDevice/GetAllStudentDevices', data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/studentDevice.service.js